interface DataRowProps {
  label: string;
  value: string | number | null | undefined;
  formatFunction?: (value: any) => string;
}

const DataRow = ({ label, value, formatFunction }: DataRowProps) => {
  const displayValue = formatFunction ? formatFunction(value) : value;

  return (
    <div className='flex justify-between py-2 border-t border-gray-200 dark:border-gray-700'>
      <span className='text-[10px] text-gray-700 dark:text-gray-400'>
        {label}
      </span>
      <span className='text-[10px] dark:text-white'>{displayValue}</span>
    </div>
  );
};

export default DataRow;
